import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { Ladder } from 'src/models/ladder.model';
import { Match } from 'src/models/match.model';
import { Pairing } from 'src/models/pairing.model';
import { Player } from 'src/models/player.model';
import { UserService } from 'src/services/user.service';
import { RecordService } from '../record/record.service';
import { DateTime } from 'luxon';

@Component({
  selector: 'record-tiebreak-match',
  templateUrl: './record.component.html',
  styleUrls: ['./record.component.scss'],
})
export class RecordTiebreakMatchComponent implements OnInit {
  public DateTime: any = DateTime;
  //public possibleScores: number[] = [...Array(8).keys()];
  public possibleTieScores: number[] = [...Array(11).keys()];
  private validScores: string[][] = [['10', '9'], ['10', '8'], ['10', '7'], ['10', '6'], ['10', '5'], ['10', '4'], ['10', '3'], ['10', '2'], ['10', '1'], ['10', '0']];
  public player: Player = new Player();
  public pairings: Pairing[] = [];
  public busy: boolean = false;
  public busySave: boolean = false;
  public ladderOver: boolean = false;
  public matchForm: FormGroup;
  public round: number;
  public ladderInfo: Ladder;


  constructor(private authorizeService: AuthorizeService, private recordSvc: RecordService,
    private userSvc: UserService, private http: HttpClient, private fb: FormBuilder, private router: Router) {
    this.busy = true;

    this.matchForm = this.fb.group({
      opponentId: new FormControl(null),  //number
      pairingId: new FormControl(),
      Set1Player1Score: new FormControl('0'),
      Set1Player2Score: new FormControl('0'),
      Set2Player1Score: new FormControl('0'),
      Set2Player2Score: new FormControl('0'),
      Set3Player1Score: new FormControl('0'),
      Set3Player2Score: new FormControl('0'),

      Set1Player1Tie: new FormControl('0'),
      Set1Player2Tie: new FormControl('0'),
      Set2Player1Tie: new FormControl('0'),
      Set2Player2Tie: new FormControl('0'),
      Set3Player1Tie: new FormControl('0'),
      Set3Player2Tie: new FormControl('0')
    });
    // on change of opponents, show the user what round they are recording
    this.matchForm.controls.opponentId.valueChanges.subscribe((opponentId) => {
      let o = this.pairings.find(o => o.pairingPlayer.id == opponentId);
      this.matchForm.controls.pairingId.setValue(o.pairingId);
      this.round = o.round;
    });

  }

  public ngOnInit() {
    const p1 = this.userSvc.getUser();
    const p2 = this.http.get<Pairing[]>('/pairing');
    const p3 = this.recordSvc.ladderInfo();
    forkJoin([p1, p2, p3]).subscribe(
      (resp) => {
        this.player = new Player(resp[0]);
        this.pairings.length = 0;
        for (let p of resp[1]) {
          this.pairings.push(new Pairing(p));
        }
        // fix for iphone/ipad... need to assign first player for the select - null breaks things
        if (this.pairings.length > 0)
          this.matchForm.controls.opponentId.setValue(this.pairings[0].pairingPlayer.id);

        this.ladderInfo = resp[2];
        if (DateTime.fromISO(this.ladderInfo.endDate) < DateTime.local()) this.ladderOver = true;
        this.busy = false;
      },
      (err) => {

      }
    )
  };


  public saveMatch(evt: any) {
    if (this.busySave) return;
    this.busySave = true;
    const values = this.matchForm.value;
    let m = new Match(this.matchForm.value);
    this.recordSvc.recordMatch(m).subscribe(
      (resp) => {
        // redirect back to 
        this.router.navigate(['/home']);
      },
      (err) => {
        this.busySave = false;
        alert(err.error);
      }
    )
  }

  public canSave(): boolean {
    const values = this.matchForm.value;
    if (values.opponentId == null) return false;
    if (!this.validSetScore([parseInt(values.Set1Player1Tie, 10), parseInt(values.Set1Player2Tie, 10)])) return false;
    return true;
  }

  private validSetScore(score): boolean {
    if (score[0] < score[1]) score.reverse();
    if (this.validScores.some(x => x.join() == score.join())) return true;
    else return false;
  }

}
